<div class="chip"
     [ngClass]="(selected ? 'selected ' : '') + (disclosable ? 'pointer ' : '') + (color || '') + ' ' + (size || '')"
     (click)="onClick.emit()">
   {{label}} {{count ? '(' + count + ')' : ''}}
   <i *ngIf="selected && disclosable"
      class="close fas fa-times"></i>
</div>
